import { ref } from 'vue'
import { useHttp } from '@core/composables/useHttp'

import API from '@core/api.js'

export const usePackages = () => {
  let packages = ref([])

  const { isLoading, execute } = useHttp()

  const enrichPackage = (packageItem) => ({
    ...packageItem,
    description: packageItem?.description?.split('\r\n') ?? [],
  })

  const hasSingleCreditPrice = (packageItem) =>
    packageItem?.singleCreditPrice?.price != null

  const sortByPriceAscending = (a, b) =>
    a.singleCreditPrice.price - b.singleCreditPrice.price

  execute({ url: API.packagesResource }, (items) => {
    const list = Array.isArray(items?.data) ? items.data : []

    packages.value = list
      .map(enrichPackage)
      .filter(hasSingleCreditPrice)
      .sort(sortByPriceAscending)
  })

  return { packages, isLoading }
}
